<header class="navigation" role="banner">
  <div class="navigation-wrapper">
    <h1>
      <a [routerLink]="['/']">Christians United for Israel</a>
    </h1>
  </div>
</header>
